export class BasicError extends Error {
  readonly tag = 'BasicError';
}
